import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useNavigate, useLocation } from "react-router";
import { PrismMenubar } from "@prism-ui/react";

export const isActivePath = (pathname, path) =>
  path === "/" ? pathname === "/" : pathname === path || pathname.startsWith(`${path}/`);

export const toMenuItems = (links, pathname) =>
  links.map((link) => ({
    id: link.path,
    title: link.name,
    href: link.path,
    root: true,
    active: isActivePath(pathname, link.path),
  }));

const SiteNav = ({ links }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const linkKey = links.map((l) => `${l.name}|${l.path}`).join(",");
  // PrismMenubar decorates the items it receives (parent refs), so only hand it a
  // new array when the links or active route actually change (keyed on linkKey
  // rather than the links array, which callers rebuild every render).
  const menu = useMemo(() => toMenuItems(links, pathname), [linkKey, pathname]);

  const handleClick = (e) => {
    // Prism also bubbles a data-less prismClick from the toggle; only route on items.
    const href = e.detail?.data?.href;
    if (href) navigate(href);
  };

  return (
    <PrismMenubar
      className="site-nav"
      overflow
      gap
      menu={menu}
      useCustomRouting
      onPrismClick={handleClick}
    />
  );
};

SiteNav.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({ name: PropTypes.string.isRequired, path: PropTypes.string.isRequired })
  ).isRequired,
};

export default SiteNav;
